import PDFUpload from "~/components/Input/PDFUpload";
import Messages from '~/components/Messages';
import TextChat from '~/components/Input/TextChat';
import Spinner from '~/components/svg/Spinner';
import { cn } from '~/utils/';
import { useState, useEffect } from 'react';
import PDFPreview from "~/components/PDFPreview";
import "./index.css";
import './chat.css';
import Section2 from "~/components/ui/Landing/Section2";
import Section3 from "~/components/ui/Landing/Section3";
import Section4 from "~/components/ui/Landing/Section4";
import Section5 from "~/components/ui/Landing/Section5";
import Section6 from "~/components/ui/Landing/Section6";
import { FaAngleRight } from "react-icons/fa6";
import { useConversation, usePopup } from '~/helpers/store';
import axios from "axios";
import aemo from "aemo/client";
import { scrollChatToBottom } from "~/helpers/action";
import { isPro } from '~/utils/user';

export default function Landing({ navVisible, conversationId, setNavVisible }) {
    return (
        <>
		{ conversationId === 'new' ?
			<LandingPage navVisible={navVisible} setNavVisible={setNavVisible}></LandingPage> : 
			<LandingMessage conversationId={conversationId} navVisible={navVisible} setNavVisible={setNavVisible}></LandingMessage>
		}
        </>
    );
}

const LandingPage = ({navVisible, setNavVisible}) => {
	return (
	<>
		<div className={cn('landing-container',
				{ "ml-[260px] landing-ml": navVisible }
		)}>
			{ navVisible ? <div className="overlay" onClick={()=>{setNavVisible(false)}}></div> : <></> }
			<div className="text-center">
				<div id="section-1">
					<img
						src="/assets/title-landing.png"
						alt="landing"
						className="m-auto mb-6"
						width="200"
					/>
					<div>
						<span className="bg-yellow-500 text-white px-4 py-1"
						style={{
							"borderRadius": "15px",
							"fontSize": "12px"
						}}>The Leading PDF Chat AI</span>
					</div>
					<div className="title mt-2">
						Chat with any <span className="text-blue-500">PDF</span>
					</div>
					<div className="content">
						<div className="description text-center w-full">
                            Join millions of students and professionals in using AI to quickly answer questions and gain insights from research.
						</div>
						<div className="i-content"></div>
						<PDFUpload></PDFUpload>
					</div>
				</div>
                <Section2></Section2>
                <Section3></Section3>
                <Section4></Section4>
                <Section5></Section5>
                <Section6></Section6>
			</div>
		</div>
	</>);
}

const LandingMessage = ({ conversationId, navVisible, setNavVisible }) => {
	const convoState = useConversation((state) => state);
	const pState = usePopup((state) => state);
	const [isLoading, setIsLoading] = useState(true);
	const [pageView, setPageView] = useState("pdf");
    const [ isChatSubmit, setIsChatSubmit ] = useState(false);
	const [ textStream, setTextStream ] = useState('');

	useEffect(()=>{
		if( document.querySelector('body').clientWidth <= 991 ) setPageView("chat");
	}, []);

	useEffect(()=>{
		convoState.setView(pageView);
	}, [pageView])
	
	useEffect(()=>{
		if(convoState.data?.status === 'completed') setIsLoading(false);
		else setIsLoading(true);
	}, [convoState.data]);

	const submitMessage = (prompt, cb=()=>{}) => {
		prompt = prompt.trim();
		if(!prompt) return;
		let message = convoState.message;
		message.push({
			sender: "User",
			text: prompt
		});
		convoState.setMessage(message);
		var history = [];
		convoState.message.forEach((convo)=> {
			var role = "assistant";
			if(convo.sender === 'user') role = "user";

			history.push({
				role,
				content: convo.text
			})
		});

		setIsChatSubmit(true);
		axios.post(`/api/chat`, {
			conversationId,
			prompt,
			history: JSON.stringify(history)
		}).then((resp)=> {
			const { data } = resp;
			if( !data.success ) {
				if(data.auth.status === 'invalid') {
					const auth_data = data.auth?.data;
					if(auth_data?.status === 'max-tokens') {
						if(auth_data?.ent_member === 'yes') {
						  pState.setShowPricingPopup(true);
						  return;
						}
						pState.setShowPricingPopup(true);
						return;
					}
					pState.setShowPricingPopup(true);
					return;
				}
			}
			let message = convoState.message;
			let msgCharSplit = data.response?.split("");
			setIsChatSubmit(false);
			convoState.setIsStreaming(true);
			let streamText = '';
			setTextStream('');
			let i = 0;
			
			const processStream = () => {
				let ctr = 0;
				while(ctr < 20) {
					streamText = streamText + msgCharSplit[i];
					i++;
					ctr++;
					if(i >= msgCharSplit.length) break;
				}
				setTextStream(streamText);
				
				if(i < msgCharSplit.length) {
					scrollChatToBottom();
					setTimeout(()=>{
						processStream();
					}, 1);
					return;
				}
				convoState.setIsStreaming(false);
				message.push({
					sender: data.sender,
					text: data.response
				});
				cb();
				
				convoState.setMessage(message);
				setTextStream('');
				setIsChatSubmit(false);
				
				scrollChatToBottom();
				setTimeout(()=>{
					let text_el = document.querySelector('.text-input-container input') as HTMLElement;
					if(text_el) text_el.focus();
				}, 100);
			}
			processStream();
		})
	};

	const togglePreview = () => {
		if(pageView === "chat") {
			setPageView("pdf");
			return;
		}
		setPageView("chat");
	}

	return (
	<>
		<div className={cn('pl-[20px] landing-msg',
			{ "ml-[260px] nav-visible": navVisible },
			pageView === "chat" ? "chat-view": "pdf-view",
			isPro() ? "isPro" : ""
		)}
		style={{
			"height": "100%"
		}}>
			{ navVisible ? <div className="overlay" onClick={()=>{setNavVisible(false)}}></div> : <></> }
			{ pState.showProcessLoading ? <></> : 
			<>
				<div
				style={{
					"height": "100%",
					"position": "relative"
				}}>
					<div className="pdf-preview-container">
						<PDFPreview togglePreview={togglePreview}></PDFPreview>
					</div>
					<div className="message-container">
						{	pageView === "chat" ?
							<button className={cn(`mt-[5px] hover:underline flex show-preview-btn`)} onClick={togglePreview}>Preview <FaAngleRight /></button>	: <></>
						}
						{ isLoading ? 
						<>
							<div className="loading-container">
								<Spinner className="m-auto mt-5" /> 
								<div style={{
									textAlign: "center",
									fontSize: "18px",
									marginTop: "20px"
								}}>Please wait as we process your PDF.</div>
							</div>
						</>
						:
						<>
							<div className="mb-[30px] chat-header"><b>Chat</b></div>
							<Messages submitMessage={submitMessage} isChatSubmit={isChatSubmit} textStream={textStream}></Messages>
							<TextChat submitMessage={submitMessage} isChatSubmit={isChatSubmit}></TextChat>
						</>
						}
					</div>
				</div>
			</>
			}
        </div>
	</>);
}